import React from 'react';
import { IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import route from '@src/constants/route';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import StudioExperienceBannerImg from '@src/assets/images/studio-experience-banner.svg';
import { StyledStudioExperienceBanner } from './index.style';

const StudioExperienceBanner = ({ handleCloseBanner }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleRedirectToProjects = () => {
    history.push(route.PROJECTS);
  };

  return (
    <StyledStudioExperienceBanner>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <img src={StudioExperienceBannerImg} alt="studio-experience-banner" />
        <div className="studio-experience-banner-content">
          <div className="studio-experience-banner-content-title">
            <Typography>{t('tryProjects')}</Typography>
          </div>
          <div className="studio-experience-banner-content-description">
            <Typography>{t('tryTheStudioProductDescription')}</Typography>
          </div>
        </div>
      </div>
      <div className="studio-experience-banner-content-button-container">
        <button
          onClick={handleRedirectToProjects}
          className="button-gradient"
          type="button"
        >
          {t('exploreNow')}
        </button>

        <div className="close-icon-container">
          <IconButton onClick={handleCloseBanner}>
            <CloseRoundedIcon className="close-icon" color="secondary" />
          </IconButton>
        </div>
      </div>
    </StyledStudioExperienceBanner>
  );
};

export default StudioExperienceBanner;
